import { usePage } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import type { SharedProps } from '@/types'

type Props = {
  accountType: 'user' | 'organization'
  label?: string
  className?: string
  extraFields?: Record<string, string>
  mode?: 'form' | 'button'
}

export default function GoogleOAuthButton({
  accountType,
  label = 'Continue with Google',
  className,
  extraFields,
  mode = 'form',
}: Props) {
  const { csrf_token } = usePage<SharedProps>().props

  function submitWithTemporaryForm() {
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = '/auth/google_oauth2'
    form.style.display = 'none'

    const fields = {
      authenticity_token: csrf_token,
      account_type: accountType,
      ...extraFields,
    }

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      input.value = value
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }

  const content = (
    <>
      <svg className="size-5" viewBox="0 0 24 24">
        <path
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
          fill="#4285F4"
        />
        <path
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
          fill="#34A853"
        />
        <path
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
          fill="#FBBC05"
        />
        <path
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
          fill="#EA4335"
        />
      </svg>
      {label}
    </>
  )

  if (mode === 'button') {
    return (
      <Button
        type="button"
        variant="outline"
        className={`w-full gap-2 ${className}`.trim()}
        onClick={submitWithTemporaryForm}
      >
        {content}
      </Button>
    )
  }

  return (
    <form method="POST" action="/auth/google_oauth2" className={className}>
      <input type="hidden" name="authenticity_token" value={csrf_token} />
      <input type="hidden" name="account_type" value={accountType} />
      {extraFields &&
        Object.entries(extraFields).map(([name, value]) => (
          <input key={name} type="hidden" name={name} value={value} />
        ))}
      <Button type="submit" variant="outline" className="w-full gap-2">
        {content}
      </Button>
    </form>
  )
}
